export const CHILD_CONFIRMATION_KEY = 'children-with-adult'
export const CHILD_CONFIRMATION_VALUE = 'confirm_children'

export const confirmationValue = (value = '') => {
  const key = String(value ?? '').trim()

  if (!key) {
    return ''
  }

  if (key === CHILD_CONFIRMATION_KEY || key === CHILD_CONFIRMATION_VALUE) {
    return CHILD_CONFIRMATION_VALUE
  }

  return key.startsWith('confirm_') ? key : `confirm_${key}`
}

export const normaliseConfirmationValues = (values = []) => {
  const source = Array.isArray(values)
    ? values
    : Array.isArray(values?.value)
      ? values.value
      : []

  return [...new Set(source.map(confirmationValue).filter(Boolean))]
}
